module.exports = __webpack_public_path__ + "static/media/18-7.b26ee97a.mp3";